import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import ClientSideLoggerAction from 'yoda-site-components/lib/actions/ClientLoggerAction';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { updateQuickScreenWidgetDetails } from '../../actions/SYFActions';

// eslint-disable-next-line import/prefer-default-export
export function seeSYFQuickScreenDetails(quickScreenConfig) {
    const {
        dispatch = () => {},
        dsaToken,
        scriptLoadThreshold = 5000,
        eventOrigin = 'https://widget.syf.com',
        ...qsConfig
    } = quickScreenConfig;
    const { src } = qsConfig;
    qsConfig.src = src.replace('TOKENINFO', dsaToken);
    const quantumSessionID = Cookies.load('QuantumMetricSessionID') || '';
    const accountId = Cookies.load('ACCOUNT_ID') || '';
    try {
        const startTime = performance.now();
        const onSuccess = () => {
            const callbackTime = performance.now();
            const scriptLoadTime = callbackTime - startTime;
            // eslint-disable-next-line no-console
            console.log(`Successfully loaded syfquickscreen script: ${callbackTime - startTime}`);
            quickScreenConfig.dispatch(
                updateQuickScreenWidgetDetails({ scriptDetails: { isScriptLoaded: true } })
            );
            /* istanbul ignore next */
            if (scriptLoadTime > scriptLoadThreshold) {
                const actionName = 'syf_load_delay';
                const errorDescription = 'SYF script load time exceeded the threshold value';
                quickScreenConfig.dispatch(
                    ClientSideLoggerAction.logError(
                        errorDescription,
                        `actionName: | ${actionName} | user-agent:${window?.navigator?.userAgent} | quantumSessionID:${quantumSessionID} | accountId:${accountId} | loadTime:${scriptLoadTime}`
                    )
                );
            }
        };

        const onError = () => {
            // eslint-disable-next-line no-console
            console.log('error in loading SYF quick Screen');
            quickScreenConfig.dispatch(
                updateQuickScreenWidgetDetails({
                    scriptDetails: {
                        isScriptLoaded: false,
                        removePreshellLoader: true,
                        SYFScriptFailed: true,
                    },
                })
            );
            const actionName = 'syf_loading_failed';
            const errorDescription = 'SYF script load failed';
            dispatch(
                ClientSideLoggerAction.logError(
                    errorDescription,
                    `actionName: | ${actionName} | user-agent:${window?.navigator?.userAgent} | quantumSessionID:${quantumSessionID} | accountId:${accountId}`
                )
            );
        };
        /* istanbul ignore next */
        window.addEventListener(
            'message',
            // eslint-disable-next-line func-names
            function (event) {
                if (event.origin !== eventOrigin) return;
                // eslint-disable-next-line no-console
                console.log('received response: ', event.data);
                if (event?.data?.responseText) {
                    quickScreenConfig.dispatch(
                        updateQuickScreenWidgetDetails({ widgetDetails: event?.data })
                    );
                }
                if (event?.data?.message === 'openWidget') {
                    document && document.body.classList.add('hidden-overflow');
                    quickScreenConfig.dispatch(
                        updateQuickScreenWidgetDetails({ widgetDetails: event?.data })
                    );
                } else if (
                    event?.data?.message === 'closeWidget' ||
                    event?.data?.responseText === 'close-modal'
                ) {
                    document && document.body.classList.remove('hidden-overflow');
                }
            },
            false
        );
        ScriptLoader.loadSYFQuickScreen({
            ...qsConfig,
            onSuccess,
            onError,
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Exception in quickscreen load', e);
    }
}
